import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom"
import { Tooltip } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes"
import * as Tools from "../../helpers/Tools"
import InHomeSchedulingButtons from "./InHomeSchedulingButtons";
import InfoModal from '../common/InfoModal';

const Questionnaires = ({ history, questions, inReverse, setVaccineIsRemoved, removedVaccines, isLastPatient, selectedVaccines, dictionary, onNext, onPrevious, sendResponse, firstName, mrn, cancelInHomeBooking, removeVaccine }) => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLastQuestion, setIsLastQuestion] = useState(false);
    const [isTooltTipOpen, canShowToolTip] = useState(false);
    const [openModal, canOpenPopup] = useState(false);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [vaccinesLeft, setVaccinesLeft] = useState(0);
    const individualResponses = useRef([]);

    useEffect(() => {
        if (!questions) return;
        setIsLastQuestion(currentIndex === questions.length - 1)

    }, [questions, currentIndex])

    useEffect(() => {
        if (!questions || !questions.length) return;
        if (inReverse) {
            if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[questions.length - 1].vaccineName))) {
                onClickPrevious(questions.length - 2);
            } else {
                setCurrentIndex(questions.length - 1);
            }
        } else {
            if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[0].vaccineName))) {
                goToNextPage(1);
            } else {
                setCurrentIndex(0)
            }
        }
    }, [questions, inReverse])

    useEffect(() => {
        let vaxLeft = selectedVaccines.reduce((acc, u) => {
            u.vaccines.forEach((v) => {
                if (v.isChecked) acc++;
            })
            return acc;
        }, 0)
        setVaccinesLeft(vaxLeft);
    }, [selectedVaccines])


    const goToNextPage = (potentialIndex = undefined) => {

        if (!isNaN(potentialIndex)) {

            if (potentialIndex > questions.length - 1) {
                onNext(individualResponses.current)
            } else {
                //skip next question if it was removed
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[potentialIndex].vaccineName))) {
                    goToNextPage(potentialIndex + 1);
                }
                else {
                    setCurrentIndex(potentialIndex)
                }
            }

        } else {

            if (selectedQuestions.length) {
                let userResponses = {
                    mrn: mrn,
                    vaccineName: questions[currentIndex].vaccineName,
                    vaccineResponses: selectedQuestions?.map((questionIndex) => {
                        return questions[currentIndex].items[questionIndex];
                    })
                }

                individualResponses.current.push(userResponses);
                setSelectedQuestions([]);
            }

            if (currentIndex === questions.length - 1) {
                onNext(individualResponses.current)
            } else {
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[currentIndex + 1].vaccineName))) {
                    //skip next question if it was removed
                    goToNextPage(currentIndex + 2)
                }
                else {
                    setCurrentIndex(currentIndex + 1)
                }
            }

        }
    }

    const onClickPrevious = (potentialIndex = undefined) => {

        if (!isNaN(potentialIndex)) {

            if (potentialIndex < 0) {
                onPrevious()
            } else {
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[potentialIndex].vaccineName))) {
                    //skip next question if it was removed
                    onClickPrevious(potentialIndex - 1);
                }
                else {
                    setCurrentIndex(potentialIndex)
                }
            }

        } else {
            if (currentIndex === 0) {
                onPrevious()
            } else {
                if (removedVaccines[mrn] && removedVaccines[mrn].find((v => v === questions[currentIndex - 1].vaccineName))) {
                    //skip next question if it was removed
                    onClickPrevious(currentIndex - 2)
                }
                else {
                    setCurrentIndex(currentIndex - 1)
                }
            }
        }
    }

    function onClickOnCheckBox(i) {
        markSelected(i);
    }

    const markSelected = (i) => {
        let arr = selectedQuestions;
        const isMarked = arr.includes(i);
        arr = arr.filter(item => item !== i)
        if (isMarked) {
            setSelectedQuestions([...arr])
        } else {
            setSelectedQuestions([...arr, i])
        }

    }

    const canShowPopup = () => {
        canOpenPopup(!openModal);
    }

    const toggleToolTip = () => {
        canShowToolTip(!isTooltTipOpen);
    }

    const onClickNext = () => {
        if (selectedQuestions.length > 0) {
            canShowPopup();
            if (isLastPatient && isLastQuestion) logUI(`MBHWeb.UI.InHomeSchedulingEligibility.NotEligible`, new Date(), Tools.getURLPath());
        } else {
            goToNextPage();
        }
    }

    const makeTooltipContentTag = (item) => {
        let tempItem = item;
        let temp = <span id="tooltip">allergic reaction</span>;
        let items = tempItem.split("allergic reaction");
        return <span>{items[0]} {temp} {items[1]}</span>;
    }

    const onClickOnCloseButton = () => {
        canOpenPopup(false);
    }

    const closeModal = () => {
        removeVaccine(mrn, questions[currentIndex].vaccineName)
        setVaccineIsRemoved(mrn, questions[currentIndex].vaccineName)
        canOpenPopup(false);
        goToNextPage();
    }

    const handleCancelBooking = (goHome = false) => {
        if (selectedQuestions.length) {
            let userResponses = {
                mrn: mrn,
                vaccineName: questions[currentIndex].vaccineName,
                vaccineResponses: selectedQuestions?.map((questionIndex) => {
                    return questions[currentIndex].items[questionIndex];
                })
            }

            individualResponses.current.push(userResponses);
        }
        sendResponse(individualResponses.current);
        if (goHome) navigateToHome();
        logUI(`MBHWeb.UI.InHomeSchedulingEligibility.Cancel.Clicked`, new Date(), Tools.getURLPath());
        cancelInHomeBooking()
        canOpenPopup(false);
    }

    const navigateToHome = () => {
        //debugger;
        history.push("/");
    }

    return (
        <div className="question-wrapper">
            {
                questions?.map((que, index) => {
                    return currentIndex === index && <div key={`question-${index}`}>
                        <div className="vaccine-title-wrapper">
                            <span className="vaccine-title-name">{que.vaccineName}</span>
                            {
                                que.items?.map((item, i) => {
                                    return <div className="item-wrapper" key={`item-${i}`} >
                                        <div className="item-wrapper-questions">
                                            <label>
                                                <input type="checkbox" className="question-checkbox" onClick={() => onClickOnCheckBox(i)} />
                                                <div className="checkbox-container"></div>
                                                {
                                                    item.includes("allergic reaction") ?
                                                        <span className="tooltip-container">

                                                            <Tooltip placement="top" isOpen={isTooltTipOpen} target="tooltip" toggle={toggleToolTip} className="question-tooltip">
                                                                {dictionary["allergic reaction"]}
                                                            </Tooltip>

                                                            {makeTooltipContentTag(item)}
                                                        </span>
                                                        :
                                                        <span className="tooltip-container">
                                                            <span dangerouslySetInnerHTML={{ __html: item }} />
                                                        </span>
                                                }

                                            </label>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                })
            }
            {questions && <div>
                <InfoModal
                    alignText="center"
                    hideBorder
                    className="vaccine-model"
                    showModalHeader
                    toggle={onClickOnCloseButton}
                    isOpen={openModal}
                    modalBody={
                        <div>
                            <div className="non-eligible-label">{isLastPatient && isLastQuestion && vaccinesLeft === 1 ? `You’re not eligible for the vaccine(s) that you’ve requested.` : `${firstName} is not eligible for the ${questions[currentIndex]?.vaccineName}`}</div>
                            <div className="non-eligible-msg">
                                {
                                    isLastPatient && isLastQuestion && vaccinesLeft === 1 ? `Unfortunately your responses indicate that we can not administer the vaccine (or vaccines) you’ve asked for at this time.` :
                                        <>You can <span className="non-eligible-msg-continue">continue</span> booking this appointment but this vaccine will be removed from the request.</>
                                }
                            </div>
                        </div>
                    }
                    modalFooter={
                        isLastPatient && isLastQuestion && vaccinesLeft === 1 ?
                            <div>
                                <button className={`btn btn-primary btn-continue`} onClick={() => handleCancelBooking(true)}>BACK TO HOME</button>
                            </div>
                            : <>
                                <div>
                                    <button className={`btn btn-primary btn-continue`} onClick={closeModal}>CONTINUE</button>
                                </div>
                                <div className="btn-cancel">
                                    <Link to="/" onClick={handleCancelBooking}>CANCEL BOOKING</Link>
                                </div>
                            </>}
                />
            </div>}
            <InHomeSchedulingButtons leftOnClick={onClickPrevious} rightOnClick={onClickNext} />
        </div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        cancelInHomeBooking: () => dispatch({ type: types.CANCEL_INHOME_BOOKING }),
        removeVaccine: (userMrn, vaccineName) => dispatch({ type: types.REMOVE_VACCINE, userMrn, vaccineName }),
    }
}

export default connect(null, mapDispatchToProps)(Questionnaires);